import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import CategoriesList from '../CategoriesList';

const VideoPlayer = ({ url, categories, networkCategoryIds, downloadable }) => {
  const location = useLocation();
  const videoRef = useRef();
  const [currentTime, setCurrentTime] = useState();
  const [isError, setIsError] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const playing = searchParams.has('play') || location?.state?.play;

  const onError = () => {
    setCurrentTime(videoRef.current.getCurrentTime());
    setIsError(true);
  };

  const onReady = () => {
    if (isError) {
      videoRef.current.seekTo(currentTime);
      setIsError(false);
    }
  };

  return (
    <VideoContentWrapper data-testid="video-audio-preview">
      {downloadable ? (
        <ReactPlayer
          ref={videoRef}
          url={url}
          controls
          playing={playing}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
          }}
          height="100%"
          width="100%"
          onError={onError}
          onReady={onReady}
        />
      ) : (
        <ReactPlayer
          ref={videoRef}
          url={url}
          controls
          config={{ file: { attributes: { controlsList: 'nodownload' } } }}
          playing={playing}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
          }}
          height="100%"
          width="100%"
          onError={onError}
          onReady={onReady}
        />
      )}
      <CategoriesList
        categories={categories}
        networkCategoryIds={networkCategoryIds}
      />
    </VideoContentWrapper>
  );
};

export default VideoPlayer;

const VideoContentWrapper = styled(Box).attrs({
  display: 'flex',
  maxWidth: { _: '100%', l: '72%' },
  maxHeight: { _: '100%', l: '90%' },
  height: '100%',
  width: '100%',
  alignItems: 'center',
  margin: 'auto',
  flexDirection: 'column',
  justifyContent: 'center',
})`
  > div {
    width: auto !important;
    height: auto !important;
  }
`;
